import { LOG_USER_ACTION } from './query';

export * from './constants';

export default function logUserAction(apolloClient, action) {
  if (!process.env.REACT_APP_IS_DEMO) {
    apolloClient.mutate({ mutation: LOG_USER_ACTION, variables: { action } });
  }
}
